import { PrimaryKeyValueModel } from '@shared';
import { MangoQuery, MangoQuerySelector } from 'rxdb';
import { RecordTypeEnum } from '../../models';
import { QueryOperatorsEnum } from '../../models/query-operators.enum';

export class QueryBuilder {
	private queryConditions: MangoQuerySelector<any>[] = [];

	public constructor() {}

	public addCondition(
		columnName: string,
		operator: string,
		value: string | string[] | number | number[] | boolean | RegExp | any
	): void {
		this.queryConditions.push({ [columnName]: { [operator]: value } });
	}

	public addConditionByRecordType(
		columnName: string,
		operator: string,
		value: string | string[] | number | number[] | boolean | RegExp | any,
		recordType: RecordTypeEnum
	): void {
		switch (recordType) {
			case RecordTypeEnum.depthFromToRecordType:
				this.queryConditions.push({ [columnName]: { [operator]: value } });
				break;
		}
	}

	public addPrimaryKeys(primaryKeyValue?: PrimaryKeyValueModel[]): void {
		primaryKeyValue.forEach((item: PrimaryKeyValueModel) => {
			if (!item.primaryKeyValue) {
				return;
			}
			this.addCondition(item.primaryKey, QueryOperatorsEnum.equal, item.primaryKeyValue);
		});
	}

	public build(): MangoQuery<any> {
		return {
			selector: { $and: this.queryConditions }
		};
	}
}
